import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
import { CreditTypeName } from '@core/config/credit-types/credit-type.types.ts';

export type CreditTypeColors = {
  icon: TUNDR_ICONS;
};

export type GetCreditTypeStyleProps = {
  name?: CreditTypeName;
  selected: boolean;
};

export const CreditTypeStyleMapping = ({
  name,
}: GetCreditTypeStyleProps): CreditTypeColors | null => {
  switch (name) {
    case CreditTypeName.MULTIUSE:
      return {
        icon: TUNDR_ICONS.CART,
      };
    case CreditTypeName.MOBILITY:
      return {
        icon: TUNDR_ICONS.TRAIN,
      };
    case CreditTypeName.LOCAL_CREDIT:
      return {
        icon: TUNDR_ICONS.PIN,
      };
    default:
      return null;
  }
};
